import { CxenseConfigMap, Piano } from "@ciaopeople/cp-shatsu/Ads"
import { AdCallParams } from "../AdCallParams.js"
import { AdUnit } from "../AdUnit.js"
import { AdParamsEnricher, PrebidModule } from "./PrebidModule.js"
import { CustomWindow } from "@ciaopeople/cp-shatsu/Ads"
import { isArray } from "@ciaopeople/cp-shatsu/TypeChecking"
import { VideoInfoRawData } from "../../../model/video/VideoInfo.js"
import { CP_AdvSiteName } from "../adcall/CustomParams.js"

export class PianoModule implements PrebidModule {


    private pianoImpl: Piano


    constructor(private window: Window, site?: CP_AdvSiteName) {


        let pianoProduct: keyof CxenseConfigMap = undefined

        if (site) {
            switch (site) {
                case CP_AdvSiteName.FANPAGE:
                    pianoProduct = "fanpage"
                    break;
                case CP_AdvSiteName.COOKISTIT:
                    pianoProduct = "ck_it"
                    break;
                case CP_AdvSiteName.COOKISTWOW:
                    pianoProduct = "ck_wow"
                    break;
            }
        }


        this.pianoImpl = new Piano(this.window as CustomWindow, pianoProduct)
    }

    load(): Promise<void> {
        return this.pianoImpl.init().then(_ => {
            return
        })
    }

    bidAndGetEnricher(adUnit: AdUnit, info: VideoInfoRawData): Promise<AdParamsEnricher> {

        return this.pianoImpl.getContextAndSegment()
            .then(data => {
                return (incoming) => {


                    const pianoData: { [k: string]: string } = {
                        "CxSegments": data.ids.join(","),
                        "CxContext": data.onlyContextualIds.join(","),
                    };

                    const pianoDataSerialized = Object.entries(pianoData).map(y => {
                        const [key, value] = y;
                        let uv = "";
                        if (isArray(value)) uv = value.join(",");
                        else uv = value
                        return key + "=" + uv;
                    }).join("&");


                    const targeting = encodeURIComponent(pianoDataSerialized ? pianoDataSerialized : "");

                    const useParams: AdCallParams = incoming ? incoming : {};
                    useParams.pre_serialized_custom_params = useParams.pre_serialized_custom_params || [];
                    useParams.pre_serialized_custom_params.push(targeting);
                    return useParams;
                }
            }).catch(err => {
                return Promise.reject(err);
            });

    }


}